import { atom } from "jotai";

export const isCreateExaminationModalOpenAtom = atom<boolean>(false);
